import EasyMDE from 'easymde'

const markdownEditor = container => {
  const markdownInputs = container.querySelectorAll('[data-markdown-input]')

  markdownInputs.forEach(input => initEditor(input))
}

const initEditor = input => {
  const editor = new EasyMDE({
    element: input,
    autofocus: true,
    spellChecker: false,
    forceSync: true,
    hideIcons: ['fullscreen', 'side-by-side'],
    showIcons: ['horizontal-rule']
  })

  return editor
}

export default markdownEditor
